import axiosInstance from './axiosInstance';

export const getOrdersByRestaurant = (restaurantGuid: string) =>
  axiosInstance.get(`/order/restaurant/${restaurantGuid}`);

export const getOrderById = (id: string) =>
  axiosInstance.get(`/order/${id}`);

export const createOrder = (data: any) =>
  axiosInstance.post('/order', data);

export const updateOrderStatus = async (id: string, status: string) =>
  await axiosInstance.put(`/order/${id}/status`, JSON.stringify(status), {
    headers: { 'Content-Type': 'application/json' },
  });
